import { observable, action, computed, autorun } from 'mobx'
import Parse from 'parse'
import _ from 'lodash'
import directus from '../utils/directus'
// import moment from 'moment'
// import GolfCourseStore from './GolfCourseStore'
// import DatesStore from './DatesStore'
// import ConfigStore from './ConfigStore'
// import UserStore from './UserStore'
import TranslationStore from './TranslationStore'
import config from 'react-global-configuration'

let timeout = 100

class UtilStore {

  @observable util = {}
  @observable press = []
  @observable testimonials = []
  @observable qanda = []
  @observable available_roles = []
  @observable regions = []
  @observable countries = []
  @observable benefits = [] 
  @observable partners = []
  @observable quotes = []
  @observable membershipTypes = []
  @observable golfcoursesDirectus = []
  @observable loaded = false

  @observable checkAvailibility = undefined

  @observable isPhone = false
  @observable isTablet = false

  @action setUtil = (state) => {
    this.util = state
  }

  @action setCheckAvailibility = (state) => {
    this.checkAvailibility = state
  }

  loadUtilData = async () => {
    try {

      const computeMediaQueries = () => {
        this.isPhone = window.matchMedia('(max-width: 576px)').matches
        this.isTablet = window.matchMedia('(max-width: 992px)').matches
      }

      window.onresize = computeMediaQueries
      computeMediaQueries()

      const temp = {}

      await (new Parse.Query("Util")).each(entry => {
        temp[ entry.get("slug").toLowerCase() ] = entry.get("data");
      })

      this.setUtil(temp)


      /*
      await (new Parse.Query("PressTestimonial")).notEqualTo("isHidden", true).ascending("order").find().then(entry => {
        this.press = entry.map(item => item.attributes)
      })

      await (new Parse.Query("Testimonial")).notEqualTo("isHidden", true).ascending("order").find().then(entry => {
        this.testimonials = entry.map(item => item.attributes)
      })

      await (new Parse.Query("QandA")).notEqualTo("isHidden", true).ascending("order").find().then(entry => {
        this.qanda = entry.map(item => { return { ...item.attributes, id: item.id }})
      })

      await (new Parse.Query("AvailableRoles")).notEqualTo("isHidden", true).ascending("order").find().then(entry => {
        this.available_roles = entry.map(item => item.attributes)
      })

      await (new Parse.Query("Region")).notEqualTo("isHidden", true).descending("publishedOn").find().then(entry => {
        this.regions = entry.map(item => { return { ...item.attributes, id: item.id }})
      })

      await (new Parse.Query("RegionCountry")).notEqualTo("isHidden", true).descending("publishedOn").find().then(entry => {
        this.countries = entry.map(item => item.attributes)
      })
      */

      // Send requests in parallel
      const [
        pressData,
        testimonialData,
        qandaData,
        roleData,
        regionData,
        countryData,
        benefitsData,
        partnersData,
        quotesData,
        membershipTypesData,
        golfcourseDirectusData,
      ] = await Promise.all([
        directus.get('items/press_testimonials?fields=*.*'),
        directus.get('items/testimonials?fields=*.*'),
        directus.get('items/faq?filter[type]=external&fields=*.*'), //(new Parse.Query("QandA")).notEqualTo("isHidden", true).ascending("order").find(),
        (new Parse.Query("AvailableRoles")).notEqualTo("isHidden", true).ascending("order").find(),
        (new Parse.Query("Region")).notEqualTo("isHidden", true).descending("publishedOn").find(),
        (new Parse.Query("RegionCountry")).notEqualTo("isHidden", true).descending("publishedOn").find(),
        directus.get('items/benefits?fields=*.*'),
        directus.get('items/partners?fields=*.*'),
        directus.get('items/quotes?fields=*.*'),
        directus.get('items/membership_types?fields=*.*'),
        directus.get('items/golf_courses?fields=*.*,courses.translations.*.*,hotels.hotels_id.*.*')
      ])

      this.press = pressData && pressData.data && TranslationStore.injectTranslations(pressData.data.data)
      this.testimonials = testimonialData && testimonialData.data && TranslationStore.injectTranslations(testimonialData.data.data) //testimonialData.map(item => item.attributes)
      this.qanda = qandaData && qandaData.data && TranslationStore.injectTranslations(qandaData.data.data)
      this.available_roles = roleData.map(item => item.attributes)
      this.regions = regionData.map(item => { return { ...item.attributes, id: item.id }})
      this.countries = countryData.map(item => item.attributes)
      this.benefits = benefitsData && benefitsData.data && TranslationStore.injectTranslations(benefitsData.data.data)
      this.partners = partnersData && partnersData.data && partnersData.data.data
      this.quotes = quotesData && quotesData.data && TranslationStore.injectTranslations(quotesData.data.data)
      this.membershipTypes = membershipTypesData && membershipTypesData.data && TranslationStore.injectTranslations(membershipTypesData.data.data)
      this.golfcoursesDirectus = golfcourseDirectusData && golfcourseDirectusData.data && TranslationStore.injectTranslations(golfcourseDirectusData.data.data)

      this.loaded = true
    } catch (e) {
      console.error(e)
      setTimeout(() => {
        timeout = timeout * 2
        this.loadUtilData()
      }, timeout);
    }
  }
}

const store = new UtilStore()
export default store

autorun(() => {
  if(!store.loaded)
    store.loadUtilData()

})



// WEBPACK FOOTER //
// /src/stores/UtilStore.js